import Button from "@mui/material/Button";
import Modal from "components/modal/modal";
import { AppAction, AppContext } from "helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./delete-location-set.module.scss";
import { deleteLocationsets } from "api/layer"
import { LeftPanel, RightPanel } from "helpers/constants";
import { DrawShapeSource } from "helpers/models";

function DeleteLocationSetModal() {
	const [context, dispatch] = useContext(AppContext);
	const deleteLocationSetModal = context.deleteLocationSetModal;
  const rightPanel = context.rightPanel;
  const locationSets = context.locationSets;
	const [t] = useTranslation();

	const close = (): void => {
		dispatch({
			type: AppAction.setDeleteLocationSetModal,
			payload: undefined,
		});
	};

	const deleteLocation = (): void => {
		if (!deleteLocationSetModal) {
			return;
		}

		deleteLocationsets(deleteLocationSetModal.id).then(() => {
			if (deleteLocationSetModal.id === context.currentMultipleLocations?.id) {
				dispatch({ type: AppAction.setCurrentMultipleLocations, payload: undefined });
				if (rightPanel === RightPanel.Multiple) {
					if (context.lineAnalysisPanelVisible) {
						const currentShapeSource = (context.currentShape as any)?.source;
						const targetShapePanel =
							currentShapeSource === DrawShapeSource.POLYGON ||
							currentShapeSource === DrawShapeSource.SHAPE_POLYGON
								? RightPanel.Polygon
								: RightPanel.Line;
						dispatch({ type: AppAction.setRightPanel, payload: targetShapePanel });
					} else {
						dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Empty });
					}
				}
			}
			let remainingLocationSets = locationSets?.filter((item: any) => item.id !== deleteLocationSetModal.id);
			dispatch({ type: AppAction.setLocationSets, payload: remainingLocationSets });
			dispatch({ type: AppAction.setMultipleLocationsEdit, payload: false });
			dispatch({ type: AppAction.setLeftPanel, payload: LeftPanel.Locations }); dispatch({
				type: AppAction.addSnackBarParams,
				payload: {
					title: "deleteLocationSetTitle",
					messageData: deleteLocationSetModal.name,
					message: "deleteLocationSetMessage",
				}
			})
		});

		close();
	};

	return (
		deleteLocationSetModal && (
			<Modal
				header={t("deleteSet.title")}
				opened={deleteLocationSetModal}
				onClose={close}
			>
				<div className={styles.info}>
					<div className={styles.text}>{`${t("deleteSet.prefix")}${deleteLocationSetModal.name}${t("deleteSet.suffix")}`}</div>

					<div className={styles.button}>
						<Button
							variant="text"
							color="success"
							onClick={close}
							style={{ outline: "none" }}
						>
							{t("buttons.cancel")}
						</Button>
						&nbsp;&nbsp;
						<Button
							variant="contained"
							color="error"
							onClick={deleteLocation}
						>
							{t("buttons.delete")}
						</Button>
					</div>
				</div>
			</Modal>
		)
	);
}

export default DeleteLocationSetModal;

